<template>
  <hm-content title="叫号大屏配置">
    <div class="table-panel flex item-center flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddScreen"
          >新增大屏配置</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in storeList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="screenList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column header-align="center" align="center" label="发布门店">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.storeOutlet"
              placement="top"
            >
              <span>{{ scope.row.storeOutlet }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deviceId"
          label="大屏设备编号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="noticeTitle"
          label="标题"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="备注"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="大屏状态"
        >
          <template slot-scope="scope">
            <span class="status-error" v-show="scope.row.status === 0"
              >关闭</span
            >
            <span class="status-success" v-show="scope.row.status === 1"
              >开启</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="screenList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      total: 100,
      currentPage: 1,
      pageSize: 10,
      storeOutletId: ""
    };
  },
  mounted() {
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  computed: mapGetters(["storeList", "screenList"]),
  watch: {},
  methods: {
    toAddScreen() {
      this.$router.push({ name: "AddScreen" });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryScreenList", {
        storeOutletId: this.storeOutletId,
        serverId: this.serverId,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "EditScreen",
        query: {
          id: String(row.id)
        }
      });
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("removeScreen", {
            id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "删除大屏设置成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-list {
  li {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    margin: 0;
    margin-bottom: 10px;
  }
  .item {
    line-height: 28px;
    span {
      color: #999;
    }
  }
  .order-table {
    border: 1px solid #ebebeb;
    margin-top: 12px;
    max-width: 500px;
    .order-header {
      border-bottom: 1px solid #ebebeb;
      background: #f5f7fa;
    }
    span {
      padding: 12px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ebebeb;
    }
    span:last-child {
      border-right: none;
    }
  }
}
</style>
